module.exports = __webpack_public_path__ + "static/media/ranking.6cdf0e62.png";